import { DeleteLabelAdditionalData, DeleteLabelResponse, editLabelActionTypes, deleteLabelActionTypes, createLabelActionTypes, LabelAdditionalData } from "../../labels"
import { Collection, CollectionLabel, ErrorFetchingAction, FetchErrorInfo, SuccessFetchingAction, UserDetailsActions } from "../../../.."
import { isEqualJson } from "../../../../utils/equal/equal"
import { fetchUserDataActionTypes, UserDataResponse } from '../userDataActions'
import { updateGroupDefaultViewActionTypes, UpdateGroupDefaultViewAdditionalData } from "../../groupSettings"
import { StartFetchingAction } from "../../../../utils"

export interface UserCollectionsState {
    isFetching: boolean
    data: Collection[]
    error?: FetchErrorInfo
}

export const initialUserCollectionsState: UserCollectionsState = {
    data: [],
    isFetching: false
}

export const userCollectionsReducer = (state: UserCollectionsState = initialUserCollectionsState, action: UserDetailsActions): UserCollectionsState => {
    switch (action.type) {
        case fetchUserDataActionTypes.start: {
            return {
                isFetching: true,
                data: state.data
            }
        }
        case updateGroupDefaultViewActionTypes.start: {
            const startAction = action as StartFetchingAction<UpdateGroupDefaultViewAdditionalData>

            if(!startAction?.additionalData?.collectionId) return state
            const {defaultView, collectionId} = startAction?.additionalData
            if(!defaultView || !collectionId) return state

            const data = state.data.map(c => {
                if(c.id !== collectionId) return c
                return {
                    ...c,
                    defaultView,
                }
            })
            return {
                ...state,
                data
            }
        }
        case fetchUserDataActionTypes.success: {
            const successAction = action as SuccessFetchingAction<UserDataResponse>
            const newState: UserCollectionsState = {
                ...state,
                isFetching: false,
            }            
            if(!isEqualJson(successAction.result.collections, state.data)){
                newState.data = successAction.result.collections
            }
            return {
                ...newState
            }
        }
        case createLabelActionTypes.success: {
            const successAction = action as SuccessFetchingAction<CollectionLabel, LabelAdditionalData>
            if(!successAction.additionalData) return state

            const {collectionId} = successAction.additionalData
            const newData = state.data.map((col) => {
                if(col.id !== collectionId) return col
                return {...col, collectionLabels: [...col.collectionLabels, successAction.result]}
            })

            const newState: UserCollectionsState = {
                ...state,
                data: newData,
            }
            return newState
        }
        case editLabelActionTypes.success: {
            const successAction = action as SuccessFetchingAction<CollectionLabel, LabelAdditionalData>
            
            if(!successAction.additionalData) return state
            const {collectionId} = successAction.additionalData
            
            const newData = state.data.map((col) => {
                if(col.id !== collectionId) return col
                return {...col, collectionLabels: [...col.collectionLabels.map((label) => {
                    if(label.id !== successAction.result.id) return label
                    return {...successAction.result}
                })]}
            })
            const newState: UserCollectionsState = {
                ...state,
                data: [...newData],
            }
            return newState
        }
        case deleteLabelActionTypes.success: {
            const successAction = action as SuccessFetchingAction<DeleteLabelResponse, DeleteLabelAdditionalData>

            if(!successAction.additionalData) return state

            const {labelId, collectionId} = successAction.additionalData
            
            const newData = state.data.map((col) => {
                if(col.id !== collectionId) return col
                return {...col, collectionLabels: [...col.collectionLabels.filter((label) => label.id !== labelId)]}
            })

            const newState: UserCollectionsState = {
                ...state,
                data: [...newData],
            }
            return newState

        }
        case fetchUserDataActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                isFetching: false,
                data: [],
                error: errorAction.error
            }
        }
        default:
            return state
    }
}